import React from 'react'
import {IntlProvider} from 'react-intl'
import moment from 'moment'
import messages_ru from 'translations/ru.json'
import messages_en from 'translations/en.json'
import messages_pt from 'translations/pt.json'
import {getLanguage, setLanguage} from 'utils/utils'

export const LanguageContext = React.createContext({
	lang: 'en',
	setLang: () => {}
})

const messages = {
    'ru': messages_ru,
    'en': messages_en,
    'pt': messages_pt
}

class Intl extends React.Component {
	constructor(props) {
		super(props)

		const lang = getLanguage()
		this.setMomentLanguage(lang)

		this.state = {
			lang,
			setLang: this.handleChange
		}
	}

	handleChange = async (value) => {
		setLanguage(value)
		await this.setMomentLanguage(value)

		this.setState({
			lang: value
		})
	}

	setMomentLanguage = async (lang) => {
		if (lang !== 'en') {
			await import('moment/locale/' + lang)
			moment.locale(lang)
		} else {
			moment.locale(lang)
		}
	}

    render() {
        return (
            <IntlProvider locale={this.state.lang} messages={messages[this.state.lang]}>
				<LanguageContext.Provider value={this.state}>
					{this.props.children}
				</LanguageContext.Provider>
            </IntlProvider>
        )
    }
}

export default Intl
